// import { getAggregateCollectionVolume, getTankWaterAvailabilityData, getWeatherData } from './utils'
import { getAggregateCollectionVolume, getTankWaterAvailabilityData } from './utils';


import { V020TankType } from '../../Tank';
import { AggregationGroupType } from '@iotv/datamodel-core';
import { ProxyForTankCalculatedState } from '../../../types';

const debug = !process.env.AWS_SESSION_TOKEN && false;

type AggregationFnsType = { [key in keyof ProxyForTankCalculatedState]: <T extends V020TankType>(tanks: T[], group?: AggregationGroupType) => string | number };

export const aggregationFns: AggregationFnsType = {
  // current_filled_volume: <T extends C021TankType>(tanks: T[]) => tanks.reduce((acc, curr, i) => 'number' === typeof curr.current_filled_volume ? acc + curr.current_filled_volume : acc, 0),
  // total_volume: <T extends C021TankType>(tanks: T[]) => tanks.reduce((acc, curr, i) => 'number' === typeof curr._totalVolume ? acc + curr._totalVolume : acc, 0),
  // volume_collected_yesterday: <T extends C021TankType >( tanks: T[] ) => tanks.reduce( ( acc, curr, i ) =>  'number' === typeof curr.volume_collected_yesterday ? acc + curr.volume_collected_yesterday : 0 , 0 ),
  // volume_collected_yesterday: <T extends C021TankType>(tanks: T[]) => tanks.reduce((acc, curr, i) => 'number' === typeof curr.volume_collected_yesterday ? acc + curr.volume_collected_yesterday : acc, 0),
  // volume_used_yesterday: <T extends C021TankType>(tanks: T[]) => tanks.reduce((acc, curr, i) => 'number' === typeof curr.volume_used_yesterday ? acc + curr.volume_used_yesterday : acc, 0),
  // weather_data: <T extends C021TankType>(tanks: T[]) => getWeatherData(tanks)

  // @ts-ignore
  // hack blame BTO
  current_filled_volume: <T extends V020TankType>(tanks: T[]) =>
    tanks.reduce(
      (acc, curr, i) =>
        typeof curr.current_filled_volume === 'number'
          ? acc + curr.current_filled_volume
          : typeof curr.current_filled_volume === 'string'
          ? acc + parseInt(curr.current_filled_volume)
          : acc,
      0
    ),
  // @ts-ignore
  // hack blame BTO
  total_volume: <T extends V020TankType>(tanks: T[]) =>
    tanks.reduce(
      (acc, curr, i) =>
        typeof curr._totalVolume === 'number' ? acc + curr._totalVolume : typeof curr._totalVolume === 'string' ? acc + parseInt(curr._totalVolume) : acc,
      0
    ),

  volume_collected_yesterday: <T extends V020TankType>(tanks: T[]) =>
    tanks.reduce(
      (acc, curr, i) =>
        typeof curr.volume_collected_yesterday === 'number'
          ? acc + curr.volume_collected_yesterday
          : typeof curr.volume_collected_yesterday === 'string'
          ? acc + parseInt(curr.volume_collected_yesterday)
          : acc,
      0
    ),

  volume_used_yesterday: <T extends V020TankType>(tanks: T[]) =>
    tanks.reduce(
      (acc, curr, i) =>
        typeof curr.volume_used_yesterday === 'number'
          ? acc + curr.volume_used_yesterday
          : typeof curr.volume_used_yesterday === 'string'
          ? acc + parseInt(curr.volume_used_yesterday)
          : acc,
      0
    ),

  tank_water_availability: <T extends V020TankType>(tanks: T[]) => getTankWaterAvailabilityData(tanks).water_availability,
  tank_water_availability_message: <T extends V020TankType>(tanks: T[]) => getTankWaterAvailabilityData(tanks).water_availability_message,
  updatedAt: <T extends V020TankType>(tanks: T[]) => new Date().toLocaleString('en-NZ'),
  forecastCollectionInSevenDays: <T extends V020TankType>(tanks: T[]) => getAggregateCollectionVolume(tanks),
  predicted_run_out_date: <T extends V020TankType>(tanks: T[], group?: AggregationGroupType) => {
    return group?.dailyStateHistory !== undefined ? group.dailyStateHistory.getLength() : -1;
  },
};
